import faker from 'faker';

export default Array(400)
  .fill(0)
  .map((_, index) => ({
    id: index,
    email: faker.internet.email(),
    identificadorErp: faker.lorem.words(1),
    nome: faker.name.findName(),
    senha: faker.internet.password(),
    telefone1: faker.phone.phoneNumberFormat(),
    telefone2: faker.phone.phoneNumberFormat(),
    userName: faker.internet.userName(),
    tipoUsuarioCodigo: 1,
    statusUsurioId: faker.lorem.words(1),
  }));
